import { render, staticRenderFns } from "./ceshi.vue?vue&type=template&id=86dac4bc&"
import script from "./ceshi.vue?vue&type=script&lang=js&"
export * from "./ceshi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports